export default __webpack_public_path__ + "static/media/Summer-Schedule-2026.c296c261.png";